/**
 * sc-account-icon — flips the header profile icon to black when an account
 * session token exists in browser storage (`sc_account_token`, kept by
 * assets/sc-account.js). Runs on every page; only checks the token's
 * presence, never reads it out or logs it.
 */
(function () {
  'use strict';
  var KEY = (window.SC_DEV_API_BASE ? 'scdev_account_token' : 'sc_account_token');
  function signedIn() {
    try { return !!(localStorage.getItem(KEY) || sessionStorage.getItem(KEY)); } catch (e) { return false; }
  }
  function paint() {
    var on = signedIn();
    var els = document.querySelectorAll('.sc-account-icon');
    for (var i = 0; i < els.length; i++) els[i].classList.toggle('is-signed-in', on);
  }
  paint();
  document.addEventListener('DOMContentLoaded', paint);
  window.addEventListener('storage', paint);
  window.addEventListener('sc:account', paint);
})();
